export class GroupService {
	/*@ngInject*/
	constructor($uibModal, moment, Restangular, socket, Auth, toastr) {
		let self = this;
		this.$uibModal = $uibModal;

		this.groups = [];
		this.moment = moment;
		this.Restangular = Restangular;
		this.listenerMap = new Map();
		this.socket = socket;
		this.Auth = Auth;
		this.cacheTimeout = undefined;
		this.lastAccount = undefined;
		this.lastUser = undefined;
		this.joined = false;
		this.toastr = toastr;
		this.rooms = [];

		// self.generateRoute();


	}

	onSocketEvent(event, item, array) {
		let self = this;
		self.groups = array;
		self.listenerMap.forEach((value, key) => {
			setTimeout(() => {
				value(event, item, array);
			}, 0);
		});
	}

	registerListener(context, cb, noGet) {
		let self = this;
		if (!self.lastAccount) {
			self.lastAccount = self.Auth.getCurrentAccountSync().ref;
		} else if (self.lastAccount !== self.Auth.getCurrentAccountSync().ref) {
			self.destroyService();
			self.lastAccount = self.Auth.getCurrentAccountSync().ref;
		}
		if(!self.lastUser) {
			self.lastUser = self.Auth.getCurrentUserSync()._id;
		} else if(self.lastUser !== self.Auth.getCurrentUserSync()._id) {
			self.destroyService();
			self.lastUser = self.Auth.getCurrentUserSync()._id;
		}
		let count = self.listenerMap.size;
		self.listenerMap.set(context, cb);
		// If listenermap was empty, (TODO and timer isn't running), join room, syncupdates
		if (!self.joined) {
			if (self.cacheTimeout) {
				clearTimeout(self.cacheTimeout);
				self.cacheTimeout = undefined;
			}
			let filter = {};
			let hasPrivilege = self.Auth.hasPrivilegeSync('group.index',undefined,filter);
			if(noGet) {
				self.socket.syncUpdates('group', self.groups, self.onSocketEvent.bind(self), self);
				if(hasPrivilege && filter && filter.filterParam && filter.filterParam.field == 'groups') {
					filter.filterParam.data.forEach( (group) => {
						self.socket.joinRoom(`${self.Auth.getCurrentAccountSync().ref}:*:groups:${group}`);
						self.rooms.push(`${self.Auth.getCurrentAccountSync().ref}:*:groups:${group}`);
					} );
				}else{
					self.socket.joinRoom(`${self.Auth.getCurrentAccountSync().ref}:*:groups`);
					self.rooms.push(`${self.Auth.getCurrentAccountSync().ref}:*:groups`);
				}
				return null;
			}else {
				return self.getGroups().then((groups) => {
					self.socket.syncUpdates('group', self.groups, self.onSocketEvent.bind(self), self);
					if(hasPrivilege && filter && filter.filterParam && filter.filterParam.field == 'groups') {
						filter.filterParam.data.forEach( (group) => {
							self.socket.joinRoom(`${self.Auth.getCurrentAccountSync().ref}:*:groups:${group}`);
							self.rooms.push(`${self.Auth.getCurrentAccountSync().ref}:*:groups:${group}`);
						} );
					}else{
						self.socket.joinRoom(`${self.Auth.getCurrentAccountSync().ref}:*:groups`);
						self.rooms.push(`${self.Auth.getCurrentAccountSync().ref}:*:groups`);
					}
					self.joined = true;
					return groups;
				});
			}
		} else {
			if(self.cacheTimeout) {
				clearTimeout(self.cacheTimeout);
				self.cacheTimeout = undefined;
			}
			if(noGet) {
				return null;
			}else {
				return self.getGroups();
			}
		}
	}

	destroyService() {
		let self = this;
		if (self.joined) {
			self.socket.unsyncUpdates('group', self);
			if(self.rooms && self.rooms.length > 0) {
				self.rooms.forEach( (room) => {
					self.socket.leaveRoom(room);
				} );
				self.rooms = [];
			}
		}
		self.joined = false;
		self.groups = [];
		self.listenerMap.clear();
		clearTimeout(self.cacheTimeout);
		self.cacheTimeout = undefined;
	}

	unregisterListener(context, noCache) {
		let self = this;
		if (!self.lastAccount) {
			self.lastAccount = self.Auth.getCurrentAccountSync().ref;
		} else if (self.lastAccount !== self.Auth.getCurrentAccountSync().ref) {
			self.destroyService();
			self.lastAccount = self.Auth.getCurrentAccountSync().ref;
		}
		if(!self.lastUser) {
			self.lastUser = self.Auth.getCurrentUserSync()._id;
		} else if(self.lastUser !== self.Auth.getCurrentUserSync()._id) {
			self.destroyService();
			self.lastUser = self.Auth.getCurrentUserSync()._id;
		}
		self.listenerMap.delete(context);
		if (self.listenerMap.size === 0) {
            if(noCache) {
                self.destroyService();
            }else {
                self.cacheTimeout = setTimeout(self.destroyService.bind(self), 5000);
            }
		}
	}

	unregisterAll() {
		let self = this;
		if (!self.lastAccount) {
			self.lastAccount = self.Auth.getCurrentAccountSync().ref;
		} else if (self.lastAccount !== self.Auth.getCurrentAccountSync().ref) {
			self.destroyService();
			self.lastAccount = self.Auth.getCurrentAccountSync().ref;
		}
		if(!self.lastUser) {
			self.lastUser = self.Auth.getCurrentUserSync()._id;
		} else if(self.lastUser !== self.Auth.getCurrentUserSync()._id) {
			self.destroyService();
			self.lastUser = self.Auth.getCurrentUserSync()._id;
		}
		self.listenerMap.clear();
		if (self.listenerMap.size === 0) {
			self.cacheTimeout = setTimeout(self.destroyService.bind(self), 5000);
		}
	}

	getGroups() {
		let self = this;
		if (self.groups.length > 0) {
			return new Promise(function(resolve) {
				resolve(_.cloneDeep(self.groups));
			});
		}
        let lastAccount = _.cloneDeep(self.lastAccount);
        let lastUser = _.cloneDeep(self.lastUser);
		return this.Restangular.all('groups').getList()
			.then((groups) => {
				if(lastAccount == self.lastAccount && lastUser == self.lastUser) {
					self.groups = groups;
					return _.cloneDeep(groups);
				}else {
					return [];
				}
			});
	}

    getGroupsWithQuery(query) {
        let self = this;
        return this.Restangular.all('groups').customGET('', query)
        .then((response) => {
            return _.cloneDeep(response);
        });
    }

    countGroupsWithQuery(query) {
        let self = this;
        return this.Restangular.all('groups').customGET('count', query)
        .then((response) => {
            return _.cloneDeep(response);
        });
    }

    createGroup(group) {
        let self = this;
        return self.Restangular.all('groups').post(group)
.then((response) => {
            if(response._id) {
                self.toastr.info('Group saved.');
            }else {
                self.toastr.error('Group save failed.');
                console.error(response);
            }
        });
	}

    updateGroup(group) {
        let self = this;
        return self.Restangular.one('groups',group._id).customPATCH(group)
.then((response)=>{
            if(response._id) {
                self.toastr.info('Group updated.');
            }else {
                self.toastr.error('Group update failed.');
                console.error(response);
            }
        });
    }

    removeGroup(group) {
        let self = this;
        if(typeof group.remove === 'function') {
            group.remove().then((response) => {
                self.toastr.info('Group removed.');
            })
.catch((err) => {
                console.error(err);
                self.toastr.error('Group remove failed.');
            });
        }else{
            self.Restangular.one('groups',group._id).remove()
.then((response)=>{
                self.toastr.info('Group removed.');
            })
.catch((err) => {
                console.error(err);
                self.toastr.error('Group remove failed.');
            });
        }
    }

}

export default angular.module('secutraqApp.dashboard')
	.service('groupService', GroupService);
